import { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { newsList } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";
import Pagination from "@/components/feature/Pagination";
import Breadcrumb from "@/components/feature/Breadcrumb";

const PAGE_SIZE = 5;

export default function News() {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page") || "1") || 1;

  useSeo({
    title: "影视资讯 - 顽皮的女朋友最新影视动态",
    description:
      "汇集顽皮的女朋友影视资讯，包括剧集动态、行业观察、深度访谈与市场分析，掌握影视圈最新风向。",
    keywords: "影视资讯,影视新闻,剧集动态,行业观察,顽皮的女朋友",
  });

  const sorted = useMemo(
    () => [...newsList].sort((a, b) => b.date.localeCompare(a.date)),
    []
  );

  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const pageItems = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <div className="px-4 md:px-6 py-8 md:py-10">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视资讯" }]} />

      <header className="mt-5">
        <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
          影视资讯
        </h1>
        <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-2xl">
          汇集剧集动态、行业观察、深度访谈与市场分析，为你带来新鲜、有料的影视圈资讯。
        </p>
      </header>

      {pageItems.length > 0 ? (
        <>
          <div className="mt-8 flex flex-col gap-3 md:gap-4">
            {pageItems.map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}
          </div>

          <div className="mt-10">
            <Pagination
              page={currentPage}
              totalPages={totalPages}
              onChange={(nextPage) => {
                const params = new URLSearchParams(searchParams);
                if (nextPage <= 1) params.delete("page");
                else params.set("page", String(nextPage));
                setSearchParams(params);
              }}
            />
          </div>
        </>
      ) : (
        <div className="mt-8 py-16 flex flex-col items-center text-center rounded-lg bg-background-100 border border-background-200/70">
          <span className="w-16 h-16 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-4">
            <i className="ri-newspaper-line text-3xl"></i>
          </span>
          <h2 className="font-heading font-semibold text-lg text-foreground-950">
            暂无资讯内容
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            资讯正在整理中，请稍后再来看看。
          </p>
          <Link
            to="/"
            className="mt-5 h-11 px-6 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-heading text-sm tracking-wide hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      )}
    </div>
  );
}